import { OptionModel } from 'src/app/shared/grid/filters/option.model';

export enum VmsSubmittalTypes {
    NonVMS = 0,
    Aya = 1,
    Apn = 2
}

export const VmsSubmittalTypeMap: Map<number, string> = new Map<number, string>([
    [VmsSubmittalTypes.NonVMS, 'Non-VMS'],
    [VmsSubmittalTypes.Aya, 'Aya VMS'],
    [VmsSubmittalTypes.Apn, 'Apn VMS']
]);

export const VmsSubmittalTypesList: OptionModel[] = [
    {
        id: VmsSubmittalTypes.NonVMS,
        name: VmsSubmittalTypeMap.get(VmsSubmittalTypes.NonVMS)
    },
    {
        id: VmsSubmittalTypes.Aya,
        name: VmsSubmittalTypeMap.get(VmsSubmittalTypes.Aya)
    },
    {
        id: VmsSubmittalTypes.Apn,
        name: VmsSubmittalTypeMap.get(VmsSubmittalTypes.Apn)
    }
];
